import React from 'react'
import AboutNl from "./about/nl";
import AboutFr from "./about/fr";
import AboutDe from "./about/de";
import {connect} from "react-redux";
import DisclaimerFr from "./disclaimer/fr";
import DisclaimerDe from "./disclaimer/de";
import DisclaimerNl from "./disclaimer/nl";

class Disclaimer extends React.Component {
  constructor(props) {
    super(props);
    this.language = props.intl.locale
  }

  render() {
    let language = this.language;
    if (language == "fr") {
      return <DisclaimerFr/>
    } else if (language == "de") {
      return <DisclaimerDe/>
    } else
     return <DisclaimerNl/>
  }
}

function mapStateToProps(state) {
  const {intl} = state;
  return {
    intl
  };
}
export default connect(mapStateToProps)(Disclaimer);



/** WEBPACK FOOTER **
 ** ./src/modules/helptexts/Disclaimer.js
 **/